import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import type { BaseStoreActions, BaseStoreType } from '@/types/storeTypes'
import type { GroundInvestigationPoint } from '@/stores/type/giPoint.type'
import API from '@/api/apiUrls'
import { haveMatchingIDs } from '@/utils/arrayUtils'

const { api } = useDjango()

type State = BaseStoreType<GroundInvestigationPoint>

const baseUrl = API.GI_DATA.GI_POINTS.INDEX
const baseStore: BaseStoreType<GroundInvestigationPoint> = new AppBaseStore(baseUrl, api)
const baseStoreActions: BaseStoreActions<GroundInvestigationPoint> = baseStore.actions
export const useGIPointsStore = defineStore({
  id: 'groundInvestigationPoints',
  state: (): State => ({
    ...baseStore.state,
    loading: false,
    filterFields: ['name'],
    selectedItems: [],
    selectedCollectionItems: []
  }),
  actions: {
    ...baseStoreActions,
    resetAll() {
      this.$reset()
    },

    addSelectedGIPoint(giPoint: GroundInvestigationPoint) {
      if (this.selectedItems.includes(giPoint)) {
        this.selectedItems.splice(this.selectedItems.indexOf(giPoint), 1)
      } else {
        this.selectedItems.push(giPoint)
      }
    },
    toggleSelectedGIPoints(giPoints: GroundInvestigationPoint[]) {
      if (haveMatchingIDs<GroundInvestigationPoint>(this.selectedItems, giPoints)) {
        this.setSelectedItems([])
      } else {
        this.setSelectedItems(giPoints)
      }
    },
    updateItemsFromResponse(response: { gipoint_set: GroundInvestigationPoint[] }) {
      const giPointSet = response.gipoint_set || []
      if (!giPointSet) {
        return
      }
      const giPoints = giPointSet.features
      this.addItems(giPoints)
    }
  },
  getters: {
    ...baseStore.getters,
    filteredGIPoint: (state: State) => (id: number) => {
      return state.items.find((item) => item.id === id)?.properties?.location_id
    },
    hasCoordinatesGiPoints: (state: State) => () => {
      return state.items.filter((item) => item.geometry !== null)
    },
    giPointsWithBorehole(state: State) {
      return state.items.filter((giPoint) => giPoint.properties.borehole)
    }
  }
})
